var _circle, _path, _path2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBrandPointsOnMap = function SvgBrandPointsOnMap(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.0769C23.5 17.8808 18.5 22 18.5 22C18.5 22 13.5 17.8808 13.5 15.0769C13.5 12.273 15.7386 10 18.5 10C21.2614 10 23.5 12.273 23.5 15.0769Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22L13.0231 22.5789L13.5 22.9717L13.9769 22.5789L13.5 22ZM13.5 22C13.9769 22.5789 13.977 22.5788 13.9771 22.5787L13.9775 22.5784L13.9786 22.5775L13.982 22.5746L13.9943 22.5644L14.0394 22.5266C14.0782 22.4939 14.1343 22.4463 14.2051 22.3851C14.3468 22.2627 14.5477 22.0859 14.7882 21.8653C15.2683 21.4249 15.9109 20.8056 16.5559 20.0934C17.1983 19.384 17.8583 18.5659 18.3617 17.7277C18.8556 16.9053 19.25 15.9805 19.25 15.0769C19.25 11.8696 16.6864 9.25 13.5 9.25C10.3136 9.25 7.75 11.8696 7.75 15.0769C7.75 15.9805 8.14436 16.9053 8.6383 17.7277C9.14172 18.5659 9.80169 19.384 10.4441 20.0934C11.0891 20.8056 11.7317 21.4249 12.2118 21.8653C12.4523 22.0859 12.6532 22.2627 12.7949 22.3851C12.8657 22.4463 12.9218 22.4939 12.9606 22.5266L13.0057 22.5644L13.018 22.5746L13.0214 22.5775L13.0225 22.5784L13.0229 22.5787C13.023 22.5788 13.0231 22.5789 13.5 22Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15,
    r: 1.5,
    fill: "currentColor"
  })));
};
export default SvgBrandPointsOnMap;